import {
  CountryCodes,
  Facility,
  TableFilters,
} from "~/server/types/server.interface";
import URlS from "./urls";

export async function getTableFacilities(requestBody: {
  country: CountryCodes;
  city?: string;
  levels?: string[];
  search: string;
  activities?: string[];
  subscriptionModel: number;
  tags: string[];
}): Promise<Facility[]> {
  const url = URlS.table.facilities;

  return $fetch<Facility[]>(url, {
    method: "POST",
    body: { ...requestBody },
  });
}

export async function getTableFilters(requestBody: {
  country: CountryCodes;
  subscriptionModel: number;
  city?: string;
  levels: string[];
  activities?: string[];
}): Promise<TableFilters> {
  const url = URlS.table.filters;
  return $fetch<TableFilters>(url, {
    method: "POST",
    body: { ...requestBody },
  });
}
